<template>
  <h1>Pagos</h1>
</template>

<script>
export default {}
</script>

<style></style>
